// extracted by mini-css-extract-plugin
export default {"withTextAnswers":"Answers_withTextAnswers__1XKpc","withImageAnswers":"Answers_withImageAnswers__1fobl"};